// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New doctor page (Stitch Clinical Precision) ——— */
.doctor-form-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 0 0 48px;
  background: #ffffff;
  overflow-x: hidden;
}

.doctor-form-page__header {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  padding: 24px 32px 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.doctor-form-page__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.3;
}

.doctor-form-page__breadcrumb .lucide {
  color: #94A3B8;
  flex-shrink: 0;
}

[dir='rtl'] .doctor-form-page__breadcrumb .lucide {
  transform: scaleX(-1);
}

.doctor-form-page__crumb {
  color: #64748B;
  text-decoration: none;
  transition: color 0.12s ease;
}

.doctor-form-page__crumb:hover {
  color: #0EA5E9;
}

.doctor-form-page__crumb--muted {
  pointer-events: none;
}

.doctor-form-page__crumb--current {
  color: #0EA5E9;
  font-weight: 500;
}

.doctor-form-page__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.doctor-form-page__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  flex-shrink: 0;
}

.doctor-form-page__back:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

[dir='rtl'] .doctor-form-page__back .lucide {
  transform: scaleX(-1);
}

.doctor-form-page__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.doctor-form-page__canvas {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 24px 32px 40px;
}

.doctor-form-page__canvas .doctor-form {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.doctor-form-page__hint {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.45;
}

.doctor-form-page__hint span {
  color: #F43F5E;
  font-weight: 600;
}

.doctor-form-page__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
}

.doctor-form-page__footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-inline-start: auto;
}

.doctor-form-page__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.doctor-form-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.doctor-form-page__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-weight: 500;
}

.doctor-form-page__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  color: #0F172A;
}

.doctor-form-page__btn--primary {
  padding-inline: 24px;
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.doctor-form-page__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 720px) {
  .doctor-form-page__header,
  .doctor-form-page__canvas {
    padding-left: 16px;
    padding-right: 16px;
  }

  .doctor-form-page__title {
    font-size: 20px;
  }

  .doctor-form-page__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .doctor-form-page__footer-actions {
    width: 100%;
    margin-inline-start: 0;
  }

  .doctor-form-page__footer-actions .doctor-form-page__btn {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewDoctor/style.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ——— New doctor page (Stitch Clinical Precision) ——— */\n.doctor-form-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 0 0 48px;\n  background: #ffffff;\n  overflow-x: hidden;\n}\n\n.doctor-form-page__header {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  padding: 24px 32px 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.doctor-form-page__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.doctor-form-page__breadcrumb .lucide {\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n[dir='rtl'] .doctor-form-page__breadcrumb .lucide {\n  transform: scaleX(-1);\n}\n\n.doctor-form-page__crumb {\n  color: #64748B;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.doctor-form-page__crumb:hover {\n  color: #0EA5E9;\n}\n\n.doctor-form-page__crumb--muted {\n  pointer-events: none;\n}\n\n.doctor-form-page__crumb--current {\n  color: #0EA5E9;\n  font-weight: 500;\n}\n\n.doctor-form-page__title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doctor-form-page__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.doctor-form-page__back:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n[dir='rtl'] .doctor-form-page__back .lucide {\n  transform: scaleX(-1);\n}\n\n.doctor-form-page__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.doctor-form-page__canvas {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 24px 32px 40px;\n}\n\n.doctor-form-page__canvas .doctor-form {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.doctor-form-page__hint {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.45;\n}\n\n.doctor-form-page__hint span {\n  color: #F43F5E;\n  font-weight: 600;\n}\n\n.doctor-form-page__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-top: 20px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.doctor-form-page__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-inline-start: auto;\n}\n\n.doctor-form-page__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.doctor-form-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.doctor-form-page__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-weight: 500;\n}\n\n.doctor-form-page__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.doctor-form-page__btn--primary {\n  padding-inline: 24px;\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.doctor-form-page__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 720px) {\n  .doctor-form-page__header,\n  .doctor-form-page__canvas {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .doctor-form-page__title {\n    font-size: 20px;\n  }\n\n  .doctor-form-page__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .doctor-form-page__footer-actions {\n    width: 100%;\n    margin-inline-start: 0;\n  }\n\n  .doctor-form-page__footer-actions .doctor-form-page__btn {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
